import { AxiosInstance,AxiosInstance_V2, AxiosMember} from "./client";
import {getUserIdToken} from "service/firebase/auth"
// import { useSelector } from "react-redux";
// import axios from "axios";

import dayjs from "dayjs";

// const CancelToken = axios.CancelToken;
// const source = CancelToken.source();

const getMerchantPublicKey = (merchantId) =>
  AxiosInstance.get(`/stripe-public-key?merchantId=${merchantId}`);

const getPaymentIntent = (transactionId) =>
  AxiosInstance.get(`/payment-intent?transactionId=${transactionId}`);

const addPaymentIntent = async (transactionId, merchantId,data) => {
 
  const result = await AxiosInstance.post(`/payment-intent?transactionId=${transactionId}&merchantId=${merchantId}`, data, {
    headers: { "Content-Type": "application/json",  },
  })
  return result;
}

const uploadImage = async (input, merchantId) => {
  let timeStamp = dayjs().valueOf();
  let data = {
    name: timeStamp + ".png",
    base64Image: input,
  };
  let result = await AxiosInstance.post(`/base64/${merchantId}`, data, {
    headers: {
      "Content-Type": "application/json",     },
  });
  return result;
};

const uploadImagePublic = async (input, merchantId) => {
  let timeStamp = dayjs().valueOf();
  let data = {
    name: timeStamp + ".png",
    base64Image: input,
  };
  let result = await AxiosInstance.post(`/base64/public/${merchantId}`,
    data, { headers: {"Content-Type": "application/json"} });
  return result;
};

const getCommodities = async ({
  merchantId,
  page = 1,
  count = 300,
  listing = 1,
  typeId = "1,2,3,4,5,6",
  campaignId = '',
  sourceId = '',
  categories = ''
}) => {
  const result = AxiosInstance.get(
    `/commodity?merchantId=${merchantId}&page=${page}&count=${count}&listing=${listing}&typeId=${typeId}&campaignId=${campaignId}&sourceId=${sourceId}&categories=${categories}`);
  return result
};

// const getCommodities2 = async (merchantId, page, count, listing, typeId) => {
 
//   const result = AxiosInstance.get(
//     `/commodity?merchantId=${merchantId}&page=${page}&count=${count}&listing=${listing}&typeId=${typeId}`,
//     {
//       headers: {
//         "Content-Type": "application/json",
        
//       },
//     }
//   );
//   return result
// };

const getMerchantById = async (merchantId , token=null) => {
 
  const result = AxiosMember.get(`/merchant?id=${merchantId}`, {
    headers: {
      "Content-Type": "application/json",
      authorization: token ,
    },
  });
  return result
};

const getMerchantByEmail = async (merchantEmail) => {
 
  try {
    const result = await AxiosMember.get(`/merchant?email=${merchantEmail}`, {
      headers: {
        "Content-Type": "application/json",
        
      },
    });
    return result;
  } catch (error) {}
};

const getStoreByEmail = async (storeEmail) => {
 
  try {
    const result = await AxiosMember.get(`/store?email=${storeEmail}`, {
      headers: {
        "Content-Type": "application/json",
        
      },
    });
    return result;
  } catch (error) {}
};

const getStoresByMerchantId = async (merchantId) => {
 
  const result = await AxiosMember.get(
    `/stores?merchantId=${merchantId}`, 
    {
    headers: {
      "Content-Type": "application/json",
      
      },
    }
  );
  return result
};

const getCampaigns = async (merchantId) => {
 
  const result = AxiosInstance.get(`/campaigns?merchantId=${merchantId}`, {
    headers: {
      "Content-Type": "application/json",
      
    },
  });
  return result;
};

const getCampaignByUid = async (campaignUid) => {
 
  const result = AxiosInstance.get(`/campaign?uid=${campaignUid}`, {
    headers: {
      "Content-Type": "application/json",
      
    },
  });
  return result;
};

const getTransactionById = async (id) => {
 
  const result = AxiosInstance.get(`/transaction/${id}`, {
    headers: {
      "Content-Type": "application/json",
      
    },
  });
  return result
};

const getTransactionByOrderNumber = async(orderNumber) => {
 
  const result = await AxiosInstance.get(`/transaction?orderNumber=${orderNumber}`, 
   {headers:{"Content-Type": "application/json",  }});
  return result
}

const updateCommodity = async (commodityId, data) => {
 
  const result = await AxiosInstance.put(`/commodity/${commodityId}`, data, {
    headers: {
      "Content-Type": "application/json",
      
    },
     
  });
  return result;
};

const resetMerchantPassword = async (data) => {
 
  const result = await AxiosMember.post(`/merchant/reset`, data, {
    headers: { "Content-Type": "application/json" },
    
  });
  return result;
};

const resetStorePassword = async (data) => {
 
  const result = await AxiosMember.post(`/store/reset`, data, {
    headers: { "Content-Type": "application/json" },
    
  });
  return result;
};

const getBanksCode = async () => {
 
  const result = AxiosMember.get("/banks-code", {
    headers: { "Content-Type": "application/json" },
    
  });
  return result
};

const getCountries = async () => {
 
  const result = AxiosMember.get("/countries", {
    headers: { "Content-Type": "application/json" },
    
  });
  return result
};

const getMerchantFps = async (merchantId) => {
 
  const result = AxiosMember.get(`/merchant/${merchantId}/fps`, {
    headers: { "Content-Type": "application/json" },
    
  });
  return result
};

const addMerchantFps = async (merchantId, data) => {
 
  const result = await AxiosMember.post(`/merchant/${merchantId}/fps`, data, {
    headers: {
      "Content-Type": "application/json",
      
    },
  });
  return result;
};

const updateMerchantFps = async (fpsId, data) => {
 
  const result = await AxiosMember.put(`/merchant/fps/${fpsId}`, data, {
    headers: {
      "Content-Type": "application/json",
      
    },
  });
  return result;
};

const getMerchantBankIn = async (merchantId) => {
 
  const result = AxiosMember.get(`/merchant/${merchantId}/bank-in`, {
    headers: {
      "Content-Type": "application/json",
      
    },
  });
  return result
};

const addMerchantBankIn = async (merchantId, data) => {
 
  const result = await AxiosMember.post(
    `/merchant/${merchantId}/bank-in`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
        
      },
    }
  );
  return result;
};

const updateMerchantBankIn = async (bankInId, data) => {
 
  const result = await AxiosMember.put(`/merchant/bank-in/${bankInId}`, data, {
    headers: {
      "Content-Type": "application/json",
      
    },
  });
  return result;
};

const createTransaction = async (tranToCreate,logObjToRecord) => {
  if(!logObjToRecord?.logId && tranToCreate) {
    let logObjToRecord = {}
   if(tranToCreate?.merchantId) logObjToRecord.merchantId = tranToCreate.merchantId
    const result = await createTimeLog({
      type:"transaction", logObjToRecord
    })
    tranToCreate.timelogId = result.data.id
  }


return await AxiosInstance_V2.post(`/transaction`, tranToCreate);
};

const updateTransaction = async (transactionId, dataToUpdate, logObjToRecord) => {
  
  let originalLogData;
  if(logObjToRecord){
    const timeLogGot = await getTimeLog(logObjToRecord?.logId)
    originalLogData = timeLogGot.data
    console.log("originalLogData",originalLogData);

    // 必須除了要有timelog id，裡面也要有data
    if( !logObjToRecord?.logId || !originalLogData) {
      const result = await createTimeLog({
        type:logObjToRecord?.type, 
        logObjToRecord
      })
      console.log("createTimeLog result",result.data);
      originalLogData= result.data
      dataToUpdate.timelogId = result.data.id
    }
  }
  console.log("dataToUpdate",dataToUpdate);
  const result = await AxiosInstance_V2.put(
    `/transaction/${transactionId}`,
    dataToUpdate
  );
  console.log("updateTransaction");
  if(logObjToRecord && (result.status === 200 || result.status === 204)){
    await updateTimeLog({
      action:logObjToRecord.action , 
      type:logObjToRecord.type,
      dataToUpdate,
      logObjToRecord, 
      originalLogData
    })
  }
  return result;  

  
};

const verifyClientWithTempCode =  async ({ email, verifyCode }) => {
  try {    
    const { data: { token } } = await AxiosMember.get(`/client/token?email=${email}&code=${verifyCode}`)
    return token
  } catch (error) {
    return null
  }
}

const getClient =  async (phoneNumber) =>{
  // const idToken = await getUserIdToken();
  const result = await AxiosMember.get(`/client?phone=${phoneNumber}`, 
    // {headers:{"Content-Type": "application/json",  authorization: idToken}}
  )
  return result

}

const getClientByPhone = async (phoneNumber) => {
 
  const result = await AxiosMember.get(`/client?phone=${phoneNumber}`, {
    headers: {
      "Content-Type": "application/json",
      
    },
  });
  return result;
};

const getClientByEmail = async (email) => {
 
  const result = await AxiosMember.get(`/client?email=${email}`, {
    headers: {
      "Content-Type": "application/json",
      
    },
  });
  return result;
};

const createClient = async (data) => {
 
  const result = await AxiosMember.post(`/client`, data, {
    headers: {
      "Content-Type": "application/json",
      
    },
  });
  return result;
};

const updateClient = async (clientId, data) => {
 console.log("updateClient data",data);
  const result = await AxiosMember.put(`/client/${clientId}`, data, {
    headers: {
      "Content-Type": "application/json",
      
    },
  });
  return result;
};

const addCommodities = async (merchantId, commodities) => {
 
  const result = await AxiosInstance.post(`/commodities?merchantId=${merchantId}`, commodities, {headers:{"Content-Type": "application/json",  }});
  return result
}

const addCommodityAdditional = async (additionalIds, commodityId) => {
 

  const result = await AxiosInstance.post(`/commodity/additional?commodityId=${commodityId}`, additionalIds, {
    headers: {
      "Content-Type": "application/json",
      
    }
  });
  return result
}

/** @param {array} additionalIds */
const deleteCommodityAdditional = async (additionalIds, commodityId) => {
 

  const data = {
    additionalId: additionalIds,
    commodityId: commodityId
  }

  const result = await AxiosInstance.delete(`/commodity/additional`, {
    data: data,
    headers: {
      "Content-Type": "application/json",
      
    }
  })
  return result
}

/** @param {array} additionalIds */
const deleteCommodityAttribute = async (attributeIds) => {
 

  const result = await AxiosInstance.delete(`/commodities/attribute`, {
    data: attributeIds,
    headers: {
      "Content-Type": "application/json",
      
    }
  })
  return result
}

const deleteCommodity = async(commodityId) =>{
 
  const result = await AxiosInstance.delete(`/commodity/${commodityId}`, {headers:{"Content-Type": "application/json",  }});
  return result
}
  
const getMerchants = async(page, count) =>{
  const idToken = await getUserIdToken()
  const result = AxiosMember.get(`/merchants?page=${page}&count=${count}`, {headers:{"Content-Type": "application/json",  }})
  return result
}

const addMerchant = async(data) => {
 

  const result = await AxiosMember.post(`/merchant`, data, {headers:{"Content-Type": "application/json",  }})
  return result
}

const updateMerchant = async(data) => {
 

  const result = await AxiosMember.put(`/merchant`, data, {headers:{"Content-Type": "application/json",  }})
  return result
}

const deleteMerchant = async (email) =>{
 
  AxiosMember.delete(`/merchant?email=${email}`, {headers:{"Content-Type": "application/json",  }});

}

const addStore = async(data) => {
 

  const result = await AxiosMember.post(`/store`, data, {headers:{"Content-Type": "application/json",  }})
  return result
}

const updateStore = async(data) => {
 

  const result = await AxiosMember.put(`/store`, data, {headers:{"Content-Type": "application/json",  }})
  return result
}

const deleteStore = async(email) =>{
 

AxiosMember.delete(`/store?email=${email}`,  {headers:{"Content-Type": "application/json",  }});
}




// const addTransactionWithoutCommodity =  async(data) => {
//   const result = await AxiosInstance.post(`/transaction`, data, {headers:{"Content-Type": "application/json",  }})
//   return result
// }

const addTransaction =   async(data) => {
 
  const result = await AxiosInstance.post(`/transaction`, data, 
  {headers:{"Content-Type": "application/json",  }})
  return result
  
}


const deleteTransaction = async(transactionId) => {
 
  const result = AxiosInstance.delete(`/transaction/${transactionId}`,  {headers:{"Content-Type": "application/json",  }})
  return result;
}





const refundTransaction = async(transactionId, merchantId) =>{
 
  const result = await AxiosInstance.delete(`/payment-intent?transactionId=${transactionId}&merchantId=${merchantId}`,  {headers:{"Content-Type": "application/json",  }});
  return result
}



const getTransReportWithCommodity = async(merchantId, fromDate, toDate, signal=null) =>{
 

  const result = await AxiosInstance.get(`/transaction-detail-summary?merchantId=${merchantId}&fromDate=${fromDate}&toDate=${toDate}`,  
  {headers:{"Content-Type": "application/json", 
   
   signal
  }})
  return result

}

 const getTransReportWithStores = async(merchantId, fromDate, toDate, signal=null) =>{
 

  const result = await AxiosInstance.get(`/transaction-store-summary?merchantId=${merchantId}&fromDate=${fromDate}&toDate=${toDate}`, 
   {headers:{"Content-Type": "application/json",  
   },
   signal
  })
  return result

}

const getTransReportWithPayment = async(merchantId, fromDate, toDate, signal=null) =>{
 

  const result = await AxiosInstance.get(`/transaction-payment-type-summary?merchantId=${merchantId}&fromDate=${fromDate}&toDate=${toDate}`, 
   {headers:{"Content-Type": "application/json", 
    
    signal
  }})
  return result

}

const deleteTransactionDetail = async(transactionDetailId) => {
 
  const result = AxiosInstance.delete(`/transaction-detail/${transactionDetailId}`,  {headers:{"Content-Type": "application/json",  }})
  return result;
}


const createCampaign = async (data) => {
 
  const result = await AxiosInstance.post(`/campaign`, data, {
    headers: {
      "Content-Type": "application/json",
      
    },
  });
  return result;
};

const updateCampaign = async(campaignId, data) => {
 
  const result = await AxiosInstance.put(`/campaign/${campaignId}`,data ,  {
    headers: {
      "Content-Type": "application/json",
      
    },
  });
  return result;
}

const getPromotionLogicTemplate = async (merchantId) => {
 
  const result = AxiosInstance.get(`/promotion-logic-templates?merchantId=${merchantId}`, {
    headers: { "Content-Type": "application/json" },
    
  });
  return result
};

const getPromotionLogic = async (merchantId) => {
 
  const result = AxiosInstance.get(`/promotion-logics?merchantId=${merchantId}`, {
    headers: { "Content-Type": "application/json" },
    
  });
  return result
};

const createPromotionLogic = async (data) => {
 
  const result = await AxiosInstance.post(`/promotion-logic`, data, {
    headers: {
      "Content-Type": "application/json",
      
    },
  });
  return result;
};

const updatePromotionLogic = async(promotionLogicId, data) => {
 
  const result = await AxiosInstance.put(`/promotion-logic/${promotionLogicId}`,data,  {
    headers: {
      "Content-Type": "application/json",
      
    },
  });
  return result;
}

const deletePromotionLogic = async(logicId) =>{
 
  AxiosInstance.delete(`/promotion-logic/${logicId}`, {headers:{"Content-Type": "application/json",  }});

}

const getTemplates = async ({merchantId,campaignId}) => {
 
  const result = AxiosMember.get(`/templates?merchantId=${merchantId}&campaignId=${campaignId}`,{
    headers: {
      "Content-Type": "application/json",
      
    }
  })
  return result
};
  

const getTemplate = async ({templateId,merchantId}) => {
 
  const result = AxiosMember.get(`/template/${templateId}?merchantId=${merchantId}`, {
    headers: {
      "Content-Type": "application/json",
      
    },
  });
  return result
};
  

const createTemplate = async (data) => {
 
  const result = AxiosMember.post("/template",data, {
    headers: {
      "Content-Type": "application/json",
      
    },
  });
  return result
};

const updateTemplate = async (templateId,data) => {
 
  const result = AxiosMember.put(`/template/${templateId}`,data, {
    headers: {
      "Content-Type": "application/json",
      
    },
  });
  return result
};

const verifyClaimCode = async(merchantId, claimCode)=>{
  const result = AxiosInstance.get(`/verify/code?merchantId=${merchantId}&code=${claimCode}`);
  return result
}

const generateOptCode = async(email)=>{
  const result = AxiosMember.post(`/client/otp?email=${email}`)
  return result
}


const verifyOtpCode = async(email, optCode)=>{
  const result = AxiosMember.get(`/client/otp?email=${email}&code=${optCode}`);
  return result
}

const getTransByClient =  async(clientId)=>{
  const result = AxiosInstance.get(`client/${clientId}/transactions`);
  return result
}

const getToCToPData = (transactionId) =>{
  const result = AxiosInstance_V2.get(`/2c2p/${transactionId}`);
  return result;
}

const createVyneUrl = async ({ transactionId, callbackUrl, orderNumber }) => {
  return await AxiosInstance_V2.post(`/vyne/v1/partners/payments`, {
    transactionId,
    callbackUrl,
    mediaType: "URL",
    countries: ["GB"],
    description: orderNumber,
    customerReference: orderNumber,
    merchantReference: orderNumber,
    expiration: {
      unit: "MINUTES",
      value: 60
    },
    identifier: "GBP2",
  })
}

const checkVynePayment = async (transactionId) =>
  AxiosInstance_V2.get(`/vyne/v1/partners/payments/${transactionId}`)

const getSbp = transactionId =>
  AxiosInstance_V2.get(`/sbp/${transactionId}`)

  const campaignApi = {
    getPlural:   async (merchantId) =>  await AxiosInstance.get(`/campaigns?merchantId=${merchantId}`),
    getById:  async (campaignId) =>  AxiosInstance.get(`/campaign?id=${campaignId}`),
    getByUid: async (campaignUid, merchantId) =>  AxiosInstance.get(`/campaign?uid=${campaignUid}&merchantId=${merchantId}`),
    create: async(data) =>  await AxiosInstance.post(`/campaign`, data),
    update: async(campaignId,data) =>  await AxiosInstance.put(`/campaign/${campaignId}`, data),
    delete: async(campaignId) =>  await AxiosInstance.delete(`/campaign/${campaignId}`) 
  }

  const templateApi = {
    getPlural: async(merchantId)=> await AxiosMember.get(`templates?merchantId=${merchantId}`),
    getByCnMId: async({campaignId,merchantId})=> await AxiosMember.get(`template?campaignId=${campaignId}&merchantId=${merchantId}`),
    getByTnMId: async({templateId,merchantId})=> await AxiosMember.get(`template/${templateId}?merchantId=${merchantId}`),
    create: async(data  )=> await AxiosMember.post(`template`,data),
    update: async(templateId,merchantId)=> await AxiosMember.update(`template/${templateId}?merchantId=${merchantId}`),
    delete: async(templateId,merchantId)=> await AxiosMember.delete(`template/${templateId}?merchantId=${merchantId}`),
  
  }

  const getCurrencies = async()=>{
    const result = AxiosMember.get("currencies");
    return result
  }
const createTimeLog = async( {
  type, 
   logObjToRecord
}
  ) =>{
  console.log("createTimeLog logObjToRecord",logObjToRecord);
  const result = await AxiosMember.post("/timelog",
  {
   merchantId: logObjToRecord?.merchantId ?? 1,
   timelog: [
       {
         id: 1,
         action: "create",
          message :  [`The ${type} was created.`], 
          remark :logObjToRecord?.remark ?? "", 
          creator : logObjToRecord?.creator ?? null, 
          createdAt : new Date(),
       }
   ]
  }
  );
  
  console.log("createTimeLog result",result);
    return result
}

const getTimeLog = async(timeLogId) => {

  const result = await AxiosMember.get(`/timelog/${timeLogId}`)
  // 假設沒有get到time log data，但有timelogId，就去create一個新的
  
  return result
}


const updateTimeLog = async({action, type, dataToUpdate=null,logObjToRecord, originLogData}) =>{
    let messageUpdated= []
     console.log("updateTimeLog action",action);

  //  假設沒有傳原本的log data，要再去get一次
     if(!originLogData && logObjToRecord?.logId){
      const timeLogGot = await getTimeLog(logObjToRecord?.logId)
      originLogData = timeLogGot.data
     }


    if(action === "update" && dataToUpdate){
      // 去除不要顯示的message field
      delete dataToUpdate?.timelogId

      const dataList = Object.keys(dataToUpdate)
      console.log("dataList",dataList);


      // 由於stateId和paymentId是number，要轉換成string來顯示updated message
      // if(type === "transaction" &&
      //  (dataToUpdate["stateId"] !== logObjToRecord.prevData["stateId"] ||
      //  dataToUpdate["paymentType"] !== logObjToRecord.prevData["paymentType"] 
      //  )){
      //   const tranState = stringfyTranStateId(dataToUpdate.stateId)
      //   const tranPayment = stringfyPaymentId(dataToUpdate.paymentType)
      //   messageUpdated.push(`The order was ${tranState} by using ${tranPayment} method`)
      // }
      
      for(let i =0; i < dataList.length; i++  ){
        if(dataToUpdate[dataList[i]] !== logObjToRecord.prevData[dataList[i]]){
        messageUpdated.push(`The ${dataList[i]} field was updated from ${logObjToRecord.prevData[dataList[i]]} to ${dataToUpdate[dataList[i]]}.`)
      }
    }
  }

  console.log("logObjToRecord",logObjToRecord);
  console.log("originLogData",originLogData);
  
  // 要有原始timeLogData和logId，才執行timeLog更新
  if(originLogData && logObjToRecord?.logId){
    const result = await AxiosMember.put(`/timelog/${logObjToRecord?.logId}`, {
      merchantId: logObjToRecord.merchantId,
      timelog: [
          ...originLogData.timelog,
          {
            id: originLogData.timelog.length + 1,
            action: action === "update" ? "update" : "delete",
            message : action === "update" ? messageUpdated : [`The ${type} was deleted.`] , 
            remark :logObjToRecord?.remark ?? "", 
            ...(logObjToRecord?.rating && { rating: logObjToRecord?.rating }),
            creator : logObjToRecord?.creator ?? null, 
            comment: logObjToRecord?.comment ?? "",
            createdAt : new Date()
          }
          
      ]
    })
    console.log("updateTimeLog result",result);  
  }

}
const timeLogApi = {
  // 获取时间日志
  get: async (timeLogId) => {
    try {
      return await AxiosMember.get(`/timelog/${timeLogId}`);
    } catch (error) {
      // 如果获取失败，并且有timeLogId，则创建新的时间日志
      if (timeLogId) {
        return await timeLogApi.create({ type: 'Unknown', logObjToRecord: { logId: timeLogId } });
      }
      throw error; // 如果没有timeLogId，则抛出错误
    }
  },

  // 创建时间日志
  create: async ({ type, logObjToRecord }) => {
    console.log("createTimeLog logObjToRecord", logObjToRecord);
    const result = await AxiosMember.post("/timelog", {
      merchantId: logObjToRecord?.merchantId ?? 1,
      timelog: [{
        id: 1,
        action: "create",
        message: [`The ${type} was created.`],
        remark: logObjToRecord?.remark ?? "",
        creator: logObjToRecord?.creator ?? null,
        createdAt: new Date(),
      }]
    });
    console.log("createTimeLog result", result);
    return result;
  },

  // 更新时间日志
  update: async ({ action, type, dataToUpdate = null, logObjToRecord, originLogData }) => {
    let messageUpdated = [];
    console.log("timeLogApi.update action", action);

    // 如果没有传递原始日志数据，则再次获取
    if (!originLogData && logObjToRecord?.logId) {
      const timeLogGot = await timeLogApi.get(logObjToRecord.logId);
      originLogData = timeLogGot.data;
    }

    // 如果有更新的数据
    if (action === "update" ) {
      // 去除不要显示的message field
      // delete dataToUpdate?.timelogId;

      let dataList;
     if(dataToUpdate)  dataList = Object.keys(dataToUpdate);
      console.log("dataList", dataList);

      // 处理特定字段更新的消息
      // 这里省略了`tranStateIdToStr`和`paymentTypeToStr`函数的实现
      // 假设它们用于将状态ID和支付类型转换为可读的字符串

      // 更新时间日志数据
      if (originLogData && logObjToRecord?.logId) {
        const result = await AxiosMember.put(`/timelog/${logObjToRecord.logId}`, {
          merchantId: logObjToRecord.merchantId,
          timelog: [
            ...originLogData.timelog,
            {
              id: originLogData.timelog.length + 1,
              action: action === "update" ? "update" : "delete",
              message: action === "update" ? messageUpdated : [`The ${type} was deleted.`],
              remark: logObjToRecord?.remark ?? "",
              creator: logObjToRecord?.creator ?? null,
              comment: logObjToRecord?.comment ?? "",
              createdAt: new Date(),
            }
          ]
        });
        console.log("timeLogApi.update result", result);
      }
    }
  }
};

const commodityApi = {
  getById: async(id) =>  await AxiosInstance.get(`/commodity/${id}`),
  getByPlural : async ({
    merchantId,
    storeId = '',
    page = 1,
    count = 300,
    listing = '',
    typeId = '',
    category = '',
    campaignId = '',
    sourceId = '',
  }) => {
    const params = new URLSearchParams({
      merchantId,
      storeId,
      page: page.toString(),
      count: count.toString(),
      listing,
      typeId,
      category,
      campaignId,
      sourceId,
    });
  
    return await AxiosInstance.get(`/commodity?${params}`);
  },
  create: async ({merchantId, commodity,logObjToRecord}) => {
    console.log("commodity",commodity);
    if(logObjToRecord && !logObjToRecord?.logId) {
      const result = await timeLogApi.create(
        {
        type:"item", 
        logObjToRecord
      })
      commodity.timelogId = result.data.id
    }
    
    await AxiosInstance.post(`/commodity?merchantId=${merchantId}`, commodity,    );
  },
  createPlural:async ({merchantId, commodities,logObjToRecord}) => {
     return await Promise.all(commodities.map(async(cmdty, index) =>{
      if(logObjToRecord && !logObjToRecord?.logId) {
        const result = await timeLogApi.create({
          type:"item", 
          logObjToRecord
        })
        cmdty.timelogId = result.data.id
      }
  
        if(commodities.length === index + 1){
          const result = await AxiosInstance.post(`/commodities?merchantId=${merchantId}`, commodities)
          return result
        }
    }))
    
  },
  update: async ({commodityId, merchantId,dataToUpdate, logObjToRecord}) => {
    await AxiosInstance.put(`/commodity/${commodityId}?merchantId=${merchantId}`, dataToUpdate);
  
    let originalLogData;
     const timeLogGot = await timeLogApi.get(logObjToRecord?.logId)
    originalLogData = timeLogGot.data
  
    // 必須除了要有timelog id，裡面也要有data
    if( !logObjToRecord?.logId || !originalLogData) {
      const result = await timeLogApi.create({
          type:"item",
          logObjToRecord
        }
       )
      originalLogData= result.data
      dataToUpdate.timelogId = result.data.id
    }
  
    try{
     await timeLogApi.update({
      action:logObjToRecord.action,
      type:"item",
      dataToUpdate,
     logObjToRecord, 
      originalLogData
     })
    }
    catch(error){
      console.log("error",error);
      return error
    }
  
    
  
  },
  delete: async function ({ commodity, merchantId, logObjToRecord }) {
    const { id: commodityId, commodityCategories } = commodity
    if (!!commodityCategories.length) {
      const categoryIds = commodityCategories.map(commodityCategory => commodityCategory.categoryId).join(",")
      await this.deleteCommodityCategories({
        merchantId,
        commodityId,
        categoryIds,
      })
    }
    let originalLogData;
    if (logObjToRecord) {
      const timeLogGot = await timeLogApi.get(logObjToRecord?.logId)
      originalLogData = timeLogGot.data
      // 假設刪除前，沒有timelog id，先創造一個
      if (!logObjToRecord?.logId) {
        await this.update({ commodityId, merchantId, dataToUpdate: commodity, logObjToRecord })
        const { data } = await this.getById(commodityId)
        logObjToRecord.timelogId = data.timelogId
      } else { // 刪除前，紀錄一下timelog id
        await timeLogApi.update({
          action:"delete",
          type:"item",
          dataToUpdate:null, 
          logObjToRecord,
          originalLogData
        })
      }
    }
    await AxiosInstance.delete(`/commodity/${commodityId}?merchantId=${merchantId}`);
  },
  addCommodityAdditional : async ({additionalIds, commodityId, merchantId}) => {
    return await AxiosInstance.post(`/commodity/additional?commodityId=${commodityId}&merchantId=${merchantId}`,additionalIds);
  },
  deleteCommodityAdditional : async ({additionalIds, commodityId,merchantId}) => {
    const additionalIdQueryString = additionalIds.join(',')
    return await AxiosInstance.delete(`/commodity/additional?additionalId=${additionalIdQueryString}&commodityId=${commodityId}&merchantId=${merchantId}` )
  },
   deleteAttribute : async ({attributeIds, merchantId}) => {
    return await AxiosInstance.delete(`/commodities/attribute?merchantId=${merchantId}`, {
      data: attributeIds,
    })
  },
  addCommodityCategories : async ({ merchantId, commodityId, categoryIds }) =>
    await AxiosInstance.post(`/merchant/${merchantId}/commodity/${commodityId}/categories?categoryId=${categoryIds}`),
  deleteCommodityCategories : async ({ merchantId, commodityId, categoryIds }) =>
    await AxiosInstance.delete(`/merchant/${merchantId}/commodity/${commodityId}/categories?categoryId=${categoryIds}`)    
}

const pointsMemberApi = {
  get: async(merchantId,clientId)=> await AxiosMember.get(`/points-members/merchant/${merchantId}/client/${clientId}`),
  getAllByMerchantId: async(merchantId)=> await AxiosMember.get(`/points-members/merchant/${merchantId}`),
  getAllByClientId: async(clientId)=> await AxiosMember.get(`points-members/client/${clientId}`),
  create: async(merchantId,clientId,data)=> await AxiosMember.post(`/points-members/merchant/${merchantId}/client/${clientId}`,data),
  update: async(merchantId,clientId,data)=> await AxiosMember.put(`points-members/merchant/${merchantId}/client/${clientId}`,data),
  delete: async(merchantId,clientId)=> await AxiosMember.delete(`/points-members/merchant/${merchantId}/client/${clientId}`),
}

const getMerchantCurrencies = async (merchantId) =>
  AxiosMember.get(`/merchant/currencies?merchantId=${merchantId}`)


const getPriceLevel = async (commodityId) =>
  AxiosInstance_V2.get(`price-level/commodity/${commodityId}`)

const clientApi = {
  get: async ({ name='' , phone='', email=''}) => {
    // 构建查询参数，忽略值为空的参数
    const params = new URLSearchParams({name, phone, email });
    return await AxiosMember.get(`/client?${params}`);
  },
  getPlural: async ({merchantId}) => {
    // 构建查询参数，忽略值为空的参数
    const params = new URLSearchParams({ merchantId,count:1000 });
    return await AxiosMember.get(`/clients?${params}`);
  }
  ,
  create: async(data)=> await AxiosMember.post(`client`,data),
  update: async(clientId,data)=> await AxiosMember.put(`client/${clientId}`,data),
  delete: async(clientId)=> await AxiosMember.delete(`client/${clientId}`),
  sendEmailWithToken: async({
    email,
    openLink,
    subject,
    content,
    merchantName,
    expiredAt,
  }) => await AxiosMember.post(`/client/token`, {
    email,
    openLink,
    subject,
    content,
    merchantName,
    expiredAt,
  }),
}

const getPointExchangeRates = async (merchantId) =>
  AxiosInstance_V2.get(`/merchant/${merchantId}/point-exchange-rates/`)


export {
  uploadImage,
  uploadImagePublic,
  addPaymentIntent,
  getPaymentIntent,
  getTransactionById,
  getTransactionByOrderNumber,
  addCommodities,
  getCommodities,
  addCommodityAdditional,
  deleteCommodityAdditional,
  updateCommodity,
  deleteCommodityAttribute,
  deleteCommodity,
  getMerchants,
  getMerchantById,
  getMerchantByEmail,
  addMerchant,
  updateMerchant,
  deleteMerchant,
  resetStorePassword,
  resetMerchantPassword,
  getStoresByMerchantId,
  getStoreByEmail,
  getBanksCode,
  getCountries,
  addStore,
  updateStore,
  deleteStore,
  getMerchantFps,
  addMerchantFps,
  updateMerchantFps,
  getMerchantBankIn,
  addMerchantBankIn,
  updateMerchantBankIn,
  addTransaction,
  updateTransaction,
  deleteTransaction,
  refundTransaction,
  createClient,
  verifyClientWithTempCode,
  getClient,
  getClientByPhone,
  getClientByEmail,
  updateClient,
  getTransReportWithCommodity,
  getTransReportWithStores,
  getTransReportWithPayment,
  createTransaction,
  getMerchantPublicKey,
  deleteTransactionDetail,
  getCampaigns,
  getCampaignByUid,
  createCampaign,
  updateCampaign,
  getPromotionLogicTemplate,
  getPromotionLogic,
  createPromotionLogic,
  updatePromotionLogic,
  deletePromotionLogic,
  getTemplates,
  getTemplate,
  createTemplate,
  updateTemplate,
  verifyClaimCode,
  generateOptCode,
  verifyOtpCode,
  getTransByClient,
  getToCToPData,
  createVyneUrl,
  checkVynePayment,
  getSbp,
  getCurrencies,
  campaignApi,
  templateApi,
  commodityApi,
  createTimeLog,
  getTimeLog,
  updateTimeLog,
  pointsMemberApi,
  getMerchantCurrencies,
  getPriceLevel,
  clientApi,
  getPointExchangeRates
};

